import React, { useMemo } from 'react';
import Button from '../../../../../styled/Button';
import Distance from '../../../../../styled/Distance';
import { SelectedFiltersContainer } from '../../../../../styled/Filters/wrappers';
import { CloseIcon } from '../../../../../styled/Icon';
import useFilters from '../../Providers/useFilters';

interface ISelectedButton {
  label?: string;
  onClick: () => void;
}

const SelectedButton = ({ onClick, label }: ISelectedButton) => {
  return (
    <Button className="tone-ghost" size="small" onClick={onClick}>
      {label}
      <CloseIcon className="m-l-half adjust-top xsmall" />
    </Button>
  );
};

export default function SelectedFilters() {
  const { regularFilters, updateRegularFilters, filters, resetRegularFilters } = useFilters();

  const getMatchingFilter = (filterProperty: string) =>
    regularFilters.find((filter) => filter.property === filterProperty);

  const selected = useMemo(() => {
    return Object.entries(filters.regular).map(([property, value]) => ({
      property,
      value,
      label: getMatchingFilter(property)?.name,
    }));
  }, [filters]);

  if (!selected.length) {
    return null;
  }

  return (
    <>
      <Distance size="2" />
      <SelectedFiltersContainer>
        {selected &&
          selected.map((selectedFilter) => (
            <SelectedButton
              key={selectedFilter.property}
              label={selectedFilter.label}
              onClick={() => updateRegularFilters(selectedFilter.property, undefined)}
            />
          ))}

        {selected && selected.length > 1 && (
          <Button className="tone-ghost" size="small" onClick={resetRegularFilters}>
            Rensa alla
          </Button>
        )}
      </SelectedFiltersContainer>
    </>
  );
}
